<template>
  <div class="data-manage-box">
    <bim v-if="activeDataType === 'Bim'" />
    <rs v-if="activeDataType === 'Rs'" />
    <wmts v-if="activeDataType === 'Wmts'" />
    <osgb v-if="activeDataType === 'Osgb'" />
    <panorama v-if="activeDataType === 'Panorama'" />
    <point-cloud v-if="activeDataType === 'PointCloud'" />
    <cad v-if="activeDataType === 'Cad'" />
    <Vector v-if="activeDataType === 'Vector'" />
  </div>
</template>

<script>
import bim from "./dataManage/Bim.vue";
import rs from "./dataManage/Rs.vue";
import wmts from "./dataManage/Wmts.vue";
import osgb from "./dataManage/Osgb.vue";
import panorama from "./dataManage/Panorama.vue";
import pointCloud from "./dataManage/PointCloud.vue";
import cad from "./dataManage/Cad.vue";
import Vector from "./dataManage/Vector.vue";

import "@/assets/css/datamanage.less";

import { Store } from "@/utils/store";
import { getFileList } from "@/service/interface";

export default {
  data() {
    return {
      activeDataType: "",
      total: 0,
    };
  },
  components: {
    bim,
    rs,
    wmts,
    osgb,
    panorama,
    pointCloud,
    cad,
    Vector,
  },
  created() {
    let dataType = this.$route.query.dataType;
    this.activeDataType = dataType;
  },
  mounted() {
    if (this.isChecked("Project.Single.File.List")) {
      this.initInterval();
    }

    this.$eventManage.on("startUploadFile", this.initInterval);
  },
  beforeDestroy() {
    this.destroyInterval();

    this.$eventManage.off("startUploadFile", this.initInterval);
  },
  watch: {
    total: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$eventManage.fire("refreshTable");
      }
    },
    $route(to, from) {
      let dataType = to.query.dataType;
      this.activeDataType = dataType;
    },
  },
  methods: {
    initInterval() {
      this.queryFilesUploading().then((uploadingFiles) => {
        if (uploadingFiles.length && !this.timer) {
          this.timer = setInterval(this.refreshTable, 3000);
        }
      });
    },
    refreshTable() {
      this.queryFilesUploading().then((uploadingFiles) => {
        if (!uploadingFiles.length) {
          this.destroyInterval();
          this.$eventManage.fire("refreshTable");
        }
      });
    },
    queryFilesUploading() {
      return new Promise((resolve) => {
        let params = {
          resultCount: 1000,
          skipCount: 0,
          name: "",
          status: [0, 1, 6],
        };
        getFileList(params).then((response) => {
          if (response.isSuccess) {
            let result = response.data;
            let fileList = result.items;

            // 从上传列表中移除构件库上传的文件
            // prettier-ignore
            const schemeTypes = ["CLPrivateDoc", "CLPublicDoc", "Rvtuv","Capability", 'SceneAnnotationAttachment',"SceneAnchorPointAttachment"];
            fileList = fileList.filter(
              (el) => !schemeTypes.includes(el.scheme)
            );
            let uploaders = Store.uploaders.filter(
              (el) => !schemeTypes.includes(el.schemeType)
            );
            // 前端的上传文件列表
            let customUploadList = [];
            uploaders.forEach((uploader) => {
              let uploadFiles = uploader.uploader.uploadFiles;
              let uploadingFiles = uploader.uploader.uploadingFiles;

              customUploadList = [
                ...uploadingFiles,
                ...uploadFiles,
                ...customUploadList,
              ];
            });

            let fileUploadingList = [...fileList];
            customUploadList.forEach((item) => {
              let findIndex = fileList.findIndex((fileInfo) => {
                let bussinessInfo = fileInfo.fileBusinessInfo;
                let dataSetId = bussinessInfo.dataSetId;
                let fileName = fileInfo.fileName;
                let isSameName = fileName === item.fileName;
                let isSameDataSetId = dataSetId === item.dataSetId;
                if (isSameName && isSameDataSetId) {
                  return true;
                } else {
                  return false;
                }
              });
              if (findIndex === -1) {
                item.scheme = item.schemeType;
                fileUploadingList.push(item);
              }
            });

            this.total = fileUploadingList.length;
            resolve(fileUploadingList);
          }
        });
      });
    },
    destroyInterval() {
      this.timer && clearInterval(this.timer);
      this.timer = null;
    },
    /**
     * 权限验证
     */
    isChecked(permissionCode) {
      let permissionData = Store.permissionData;
      let find = permissionData.find(
        (el) => el.permissionCode === permissionCode
      );
      return find.isCheck;
    },
  },
};
</script>

<style lang="less" scoped>
.data-manage-box {
  flex-grow: 1;
  padding: 16px;
  padding-left: 0;
  padding-top: 0px;
}
</style>